import sendAnalyticsEvent from './sendAnalyticsEvent';
import setCookie from './setCookie';
import getCookie from './getCookie';

const cookieLifetime = 10 / (3600.0 * 24 * 60); // время жизни куки в днях

export default function timerObserver() {
  window.time_watcher = window.time_watcher || setInterval(() => {
    var startedAt = +sessionStorage.getItem('sessStarted');
    if(startedAt === 0) {
      sessionStorage.setItem('sessStarted', Date.now());
      return;
    }
    if(getCookie('minutesSend')) return;
    if(Date.now() - startedAt > 180000) {
      clearInterval(window.time_watcher);
      window.time_watcher = null;
      sendAnalyticsEvent('MINUTES_3');
      setCookie('minutesSend', 1, cookieLifetime);
    }
  }, 1000);
}
